import React from "react";
import accounting from "accounting";

const formattedValue = ({data}) => {
  const {sign, thousand_separator, decimal_mark, currency_format} = Adcurve.currency;
  return accounting.formatMoney(data, sign, 2, thousand_separator, decimal_mark, currency_format);
}

const CurrencyValue = (props) => <span>{formattedValue(props)}</span>;


export default CurrencyValue;
